module.exports = __webpack_public_path__ + "img/ikigai_snap.8faa271e.png";